import ContractListPage from './ContractListPage';
import { APPLICATION_LIST_STATUSES } from './contractTypes';

export default function Inquiries() {
  return (
    <ContractListPage
      title="신청 목록"
      desc="앱 제작 신청(1단계) 접수 후 아직 입금 확인 전인 건을 확인하고 처리할 수 있습니다."
      statusOptions={APPLICATION_LIST_STATUSES}
      groupFilter={(item) => !item.deposit_confirmed_at}
    />
  );
}
